import store from './store';
import { isNull, isUndefined } from 'lodash';

export const getKeyInStorage = (key: string) => {
  try {
    return store.get(key);
  } catch (e) {
    return undefined;
  }
};

export const hasKeyInStorage = (key: string) => {
  const storageKey = getKeyInStorage(key);
  return !isUndefined(storageKey) && !isNull(storageKey);
};

export const setKeyInStorage = (key: string, value: any) => {
  try {
    return store.set(key, value);
  } catch (e) {
    return undefined;
  }
};

export const clearItemsInStorage = store.clear;
